import "./MenuHoyPage.css";
import logoIsabel from "../assets/menu-panel/isabel-logo.png";
import nutriplanLogo from "../assets/menu-panel/nutriplan-logo-new.png";
import boltonLogo from "../assets/menu-panel/bolton-food-logo.jpeg";
import ComidaImage from "../assets/menu-panel/mexican-food-background.png";
import { useEffect, useState } from "react";
import { ApiGetAllComidasToday } from "../api/comidas";
import toast from "react-hot-toast";
import { TIPO_COMIDA, TIPO_COMIDA_LABEL } from "../utils/constanst";
import { dateLocal } from "../utils/date";
const MenuHoyPage = () => {
  const [menuSelected, setMenuSelected] = useState(null);

  const getMenuToday = async () => {
    const res = await ApiGetAllComidasToday();
    console.error("getMenuToday :::", res);
    if (res.sms === "err") {
      toast.error(res.mensaje);
      return;
    }

    const horaActual = dateLocal().split("T")[1];
    const menusOrdenados = [...res.data].sort((a, b) => {
      const horaA = a.hora_inicio;
      const horaB = b.hora_inicio;
      return horaA.localeCompare(horaB);
    });

    // Buscar el menú actual
    let menuActual = menusOrdenados.find((menu) => {
      const horaInicio = new Date(`2000-01-01T${menu.hora_inicio}`);
      const horaFin = new Date(`2000-01-01T${menu.hora_fin}`);
      const horaActualDate = new Date(`2000-01-01T${horaActual}`);

      return horaInicio <= horaActualDate && horaFin >= horaActualDate;
    });

    // Si no hay menú actual, usar el anterior o el próximo
    if (!menuActual) {
      const horaActualDate = new Date(`2000-01-01T${horaActual}`);

      // Buscar el menú anterior
      const menuAnterior = menusOrdenados.find((menu) => {
        const horaFin = new Date(`2000-01-01T${menu.hora_fin}`);
        return horaFin < horaActualDate;
      });

      // Buscar el menú próximo
      const menuProximo = menusOrdenados.find((menu) => {
        const horaInicio = new Date(`2000-01-01T${menu.hora_inicio}`);
        return horaInicio > horaActualDate;
      });

      // Si hay menú anterior, usarlo
      if (menuAnterior) {
        menuActual = menuAnterior;
      } else if (menuProximo) {
        // Si no hay anterior pero hay próximo, usar el próximo
        menuActual = menuProximo;
      }
    }

    setMenuSelected(menuActual ?? menuSelected);
  };

  const postre =
    menuSelected?.pre_detalle_comida.find(
      (item) => item.tipo === TIPO_COMIDA.POSTRE
    ) ?? null;

  const alergenos =
    menuSelected?.pre_detalle_comida.find(
      (item) => item.tipo === TIPO_COMIDA.ALERGENOS
    ) ?? null;

  const menusHoy = menuSelected?.pre_detalle_comida.filter((item) => {
    if (
      `${item.tipo}` !== `${TIPO_COMIDA.ALERGENOS}` &&
      `${item.tipo}` !== `${TIPO_COMIDA.POSTRE}`
    )
      return item;
  });

  useEffect(() => {
    getMenuToday();
    setInterval(() => {
      getMenuToday();
    }, 300000);
  }, []);
const LineByLineText = ({ text }) => {
  const lines = text.split('/');

  return (
    <ul style={{ paddingLeft: '20px' }}>
      {lines.map((line, index) => (
        <li key={index} style={{ marginBottom: '5px',fontSize:"1.3rem" ,textAlign:"left",fontWeight:"bolder"}} className="">
          {line}
        </li>
      ))}
    </ul>
  );
};
  return (
    <div
      className="container"
      style={{
        backgroundImage: `url(${ComidaImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100vh",
      }}
    >
      <div className="row justify-content-center logos ">
        <div
          className="col-md-2 d-flex align-items-center justify-content-center"
          style={{ height: "190px" }}
        >
          <div
            className="bg-white rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "180px", height: "180px", padding: "10px" }}
          >
            <img
              src={nutriplanLogo}
              alt="Logo Nutriplan"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
       
        <div
          className="col-md-2 d-flex align-items-center justify-content-center"
          style={{ height: "190px" }}
        >
          <div
            className="bg-white rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "180px", height: "180px", padding: "10px" }}
          >
            <img
              src={boltonLogo}
              alt="Logo Bolton"
              style={{
                maxWidth: "88%",
                maxHeight: "88%",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
         <div
          className="col-md-2 d-flex align-items-center justify-content-center"
          style={{ height: "190px" }}
        >
          <div
            className="bg-white rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "180px", height: "180px", padding: "10px" }}
          >
            <img
              src={logoIsabel}
              alt="Logo Isabel"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <h2 className="text-center w-25 bg-white text-dark  rounded tituloalmuerzo">
            {menuSelected?.nombre}
          </h2>
        </div>
        <div className="col-md-9 d-flex flex-column gap-3">
          {menusHoy?.map((menu, idx) => (
            <div key={menu.pre_detalle_comida_id} className=" row rounded shadow bg-white p-2">
              <div className={menu.cal === "" ? "col-md-12" : "col-md-9"}>
                <div
                  className={`card-header text-white fw-bold fs-4 border-bottom  rounded p-1 px-2 bg-${
                    idx % 2 === 0 ? "primary" : "success"
                  }`}
                >
                  {TIPO_COMIDA_LABEL[menu.tipo]}
                </div>
                <div className={`p-2 text-white bg-white text-dark`}>
                  <label
                    className="fw-bold text-center text-dark"
                    style={{ fontSize: "1.2rem" }}
                  >
                    {menu.nombre.toUpperCase()}
                  </label>
                </div>
              </div>
              {menu.cal !== "" ? (
                <div className="col-md-3 " style={{ backgroundColor: "gray" }}>
                  <div
                    style={{ color: "white" }}
                    className="d-flex justify-content-center align-items-center p-1"
                  >
                    {`Calorías ${TIPO_COMIDA_LABEL[menu.tipo]}`.toUpperCase()}
                  </div>
                  <hr className="p-0 m-0" />
                  <div
                    className="m-2 bg-white d-flex flex-row justify-content-center align-items-center"
                    style={{ fontSize: "1rem" }}
                  >
                    <label
                      htmlFor=""
                      className="mx-2"
                      style={{ fontSize: "25px" }}
                    >
                      {menu.cal}
                    </label>
                    <h5>Cal.</h5>
                  </div>
                </div>
              ) : null}
            </div>
          ))}
        </div>

        <div className="col-md-3 d-flex flex-column gap-3">
          {postre ? (
            <div
              key={postre.pre_detalle_comida_id}
              className={`card rounded-2 text-white border-2 border-warning bg-warning text-center`}
            >
              <div className="card-header bg-warning fw-bold fs-4 border-bottom p-1">
                Postre
              </div>
              <div className={`card-body p-2 text-white text-center bg-white`}>
                <p className="fw-bold   fs-4 text-dark mb-0">
                  {postre.nombre.toUpperCase()}
                </p>
                <p className="fw-bold  p-0 m-0 fs-4 text-dark">
                 ( {postre.cal} Calorías)
                </p>
              </div>
            </div>
          ) : null}

          {alergenos ? (
            <div className="card border-2  text-center">
              <div className="card-header fw-bold fs-4 bg-danger text-white ">
                ALERGENOS EN LA COMIDA
              </div>
              <div className="card-body">
                <p className="fst-italic fs-4 text-dark">
                  <LineByLineText
                    text={`${alergenos.nombre}
                  `}
                  />
                </p>
              </div>
            </div>
          ) : (
            <div className="card border-2  text-center">
              <div className="card-header fw-bold fs-4 bg-success text-white ">
                Consejo nutricional
              </div>
              <div className="card-body">
                <p className="fst-italic fs-4 text-dark">
                  "Comer sano hoy es invertir en tu salud de mañana."
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MenuHoyPage;
